import { createPinia } from 'pinia'
import type { VueConstructor } from 'vue'
import Vue from 'vue'

import { createI18n } from '../plugins/i18n'
import vuetify from '../plugins/vuetify'
import { createRouter } from '../router'

export type InstanceConfig = ReturnType<typeof createInstanceConfig>

export const createInstanceConfig = () => {
  // create translation store AFTER Vue.use
  const i18n = createI18n()
  const router = createRouter()
  const pinia = createPinia()

  return {
    i18n,
    router,
    vuetify,
    pinia,
  }
}

export const createInstance = <T extends VueConstructor<Vue>>(
  component: T,
  props: InstanceType<T>['$props'],
) => {
  const ComponentClass = Vue.extend(component)
  const config = createInstanceConfig()
  const instance = new ComponentClass({
    ...config,
    propsData: props,
  })

  return instance
}
